module.exports = __webpack_public_path__ + "static/media/20ECE5.6e1b4b2f.jpg";